import React from 'react';
import CognitoUserManagement from './CognitoUserManagement';
import Loading from '../../../../common/component/Loading';
import Config from '../../../../Config'

class CognitoUserListPerPage extends CognitoUserManagement {
  constructor(props) {
    super(props);
    this.state = {
      isLoaded: false,
      isSearched: false,
      userList: [],
      userCount: 0,
      searchName: '',
      searchBranch: '',
      searchPrefectures: '',
      searchMember: true,
      searchNonMember: true,
      searchUnapproved: true,
      searchDateStart: '',
      searchDateEnd: '',
      currentPage: 1,
      itemsPerPage: 10,
      totalPages: 1,
    };
    this.handleSearch = this.handleSearch.bind(this);
    this.handleReset = this.handleReset.bind(this);
  }

  componentDidMount() {
    const { searchName, searchBranch, searchPrefectures, searchMember, searchNonMember, searchUnapproved, searchDateStart, searchDateEnd } = this.state;
    const filters = {
      searchName: searchName,
      searchBranch: searchBranch,
      searchPrefectures: searchPrefectures,
      searchMember: searchMember,
      searchNonMember: searchNonMember,
      searchUnapproved: searchUnapproved,
      searchDateStart: searchDateStart,
      searchDateEnd: searchDateEnd,
    };
    this.loadCognitoUsersCount(filters);
    this.loadUserList(this.state.currentPage, filters);
  }

  handleSearchChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value
    });
  }

  handleSearchCheck = (e) => {
    this.setState({
      [e.target.name]: e.target.checked
    });
  };

  handlePageChange = (event) => {
    event.preventDefault();
    const { searchName, searchBranch, searchPrefectures, searchMember, searchNonMember, searchUnapproved, searchDateStart, searchDateEnd } = this.state;
    const filters = {
      searchName: searchName,
      searchBranch: searchBranch,
      searchPrefectures: searchPrefectures,
      searchMember: searchMember,
      searchNonMember: searchNonMember,
      searchUnapproved: searchUnapproved,
      searchDateStart: searchDateStart,
      searchDateEnd: searchDateEnd,
    };
    const page = parseInt(event.currentTarget.dataset.page);
    const onSuccess = (res) => {
      const userList = res.body.data.sort(this.sorter);
      this.setState({
        userList: userList,
        isSearched: true,
        currentPage: 1
      });
    };
    this.setState({ currentPage: page, isSearched: false });
    this.setState({ searchFilters: filters }, () => {
      this.loadCognitoUsersCount(filters);
      this.loadUserList(page, filters, onSuccess);
    });
  }

  handleSearch = () => {
    const { searchName, searchBranch, searchPrefectures, searchMember, searchNonMember, searchUnapproved, searchDateStart, searchDateEnd } = this.state;
    const convertToNumericDate = (dateString, appendTime = 1) => {
      if (!dateString) return null;
      const date = new Date(dateString);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      let result = `${year}${month}${day}`;
      if (appendTime == 1) {
        result += '000000';
      } else {
        result += '235959';
      }
      return Number(result);
    };
    const numericSearchDateStart = convertToNumericDate(searchDateStart, 1);
    const numericSearchDateEnd = convertToNumericDate(searchDateEnd, 0);
    let searchIsMember = null;
    let searchIsApproved = null;
    const filters = {
      searchName: searchName,
      searchBranch: searchBranch,
      searchPrefectures: searchPrefectures,
      searchMember: searchMember,
      searchNonMember: searchNonMember,
      searchUnapproved: searchUnapproved,
      searchDateStart: numericSearchDateStart,
      searchDateEnd: numericSearchDateEnd,
    };
    const onSuccess = (res) => {
      const usersList = res.body.data.sort(this.sorter);
      this.setState({
        usersList: usersList,
        isSearched: true,
        currentPage: 1
      });
    };
    this.setState({ isSearched: false, currentPage: 1 });
    this.setState({ searchFilters: filters }, () => {
      this.loadCognitoUsersCount(filters);
      this.loadUserList(this.state.currentPage, filters, onSuccess);
    });
  }

  handleReset = () => {
    this.setState({
      searchName: '',
      searchBranch: '',
      searchPrefectures: '',
      searchMember: true,
      searchNonMember: true,
      searchUnapproved: true,
      searchDateStart: '',
      searchDateEnd: '',
    });
  }

  loadUserList(pageNumber, searchData = []) {
    const onSuccess = (cognitoUsers) => {
      if (!Array.isArray(cognitoUsers)) {
        console.error('cognitoUsersは配列である必要があります');
        return;
      }

      let userList = cognitoUsers.map(({ userData, companyUserCount, logs }) => {
        const maxActionDateTime = logs.length > 0
          ? logs.reduce((max, log) => log.actionDateTime > max ? log.actionDateTime : max, logs[0].actionDateTime)
          : null;  // logsがない場合はnullを設定

        return {
          ...userData, // ユーザーのデータをそのままコピー
          companyUserCount,
          maxActionDateTime: maxActionDateTime // 最大actionDateTimeを追加
        };
      });

      // parentIDが提供されている場合、ユーザをフィルタリング
      if (this.props.parentID) {
        userList = userList.filter((u) => {
          const attributes = u.UserAttributes || [];
          const parentIDAttr = attributes.find((e) => e.Name === 'custom:ParentID');
          return parentIDAttr && parentIDAttr.Value === this.props.parentID;
        });
      }

      // ユーザを名前順にソート
      userList.sort((a, b) => {
        const aAttributes = a.UserAttributes || [];
        const bAttributes = b.UserAttributes || [];

        const aNameAttr = aAttributes.find((attr) => attr.Name === 'custom:Name');
        const bNameAttr = bAttributes.find((attr) => attr.Name === 'custom:Name');

        const aName = aNameAttr ? aNameAttr.Value : '';
        const bName = bNameAttr ? bNameAttr.Value : '';

        return aName.localeCompare(bName);
      });

      // コンポーネントの状態を更新
      this.setState({
        isLoaded: true,
        isSearched: true,
        userList: userList
      });
    };

    this.getAllUsersLoginInfoPerPage(pageNumber, this.state.itemsPerPage, searchData, onSuccess);
  }

  onPageMenuClicked(name) {
    switch (name) {
      case 'add':
        this.props.history.push('/admin/' + this.userRoleUrl + '/add');
        break;
      default:
        break;
    }
  }

  selected(user, e) {
    this.props.history.push('/admin/' + this.userRoleUrl + '/detail/' + user.id);
  }

  formatDateTime(dateTime) {
    if (!dateTime) return '';
    const dateTimeStr = dateTime.toString();
    const year = dateTimeStr.slice(0, 4);
    const month = dateTimeStr.slice(4, 6);
    const day = dateTimeStr.slice(6, 8);
    const hour = dateTimeStr.slice(8, 10);
    const minute = dateTimeStr.slice(10, 12);
    const second = dateTimeStr.slice(12, 14);
    return `${year}/${month}/${day} ${hour}:${minute}:${second}`;
  }

  renderCompanyList(userList) {
    if (!userList || userList.length === 0) {
      return (
        <tr><td colSpan='8' style={{ textAlign: 'center' }}>現時点で登録されているデータはございません。</td></tr>
      );
    }
    if(this.userRoleUrl == 'admin_user') {
      return userList.map(cognitoUser => {
        const user = {
          enabled: cognitoUser.Enabled,
          createdDateTime: cognitoUser.UserCreateDate,
          updatedDateTime: cognitoUser.UserLastModifiedDate,
          status: cognitoUser.UserStatus,
          id: cognitoUser.Username,
          email: this.arrayGet(cognitoUser.UserAttributes, 'email'),
          name: this.arrayGet(cognitoUser.UserAttributes, 'custom:Name'),
          emailNotification: this.arrayGet(cognitoUser.UserAttributes, 'custom:emailNotification'),
          prefectures: this.arrayGet(cognitoUser.UserAttributes, 'custom:prefectures'),
          branch: this.arrayGet(cognitoUser.UserAttributes, 'custom:branch'),
          administrator: this.arrayGet(cognitoUser.UserAttributes, 'custom:administrator'),
          isMember: this.arrayGet(cognitoUser.UserAttributes, 'custom:isMember'),
          parentID: this.arrayGet(cognitoUser.UserAttributes, 'custom:ParentID'),
          maxActionDateTime: this.formatDateTime(cognitoUser.maxActionDateTime),
        };
        return user;
      })
      .filter(user => user.id)
      .map(user => (
        <tr key={user.id} onClick={(e) => this.selected(user, e)}>
          <td>{user.name}</td>
          <td>{user.enabled ? '有効' : '無効'}</td>
          <td>{user.email}</td>
          <td>{this.utc2jst(user.createdDateTime)}</td>
          <td>{this.utc2jst(user.updatedDateTime)}</td>
          <td>{user.maxActionDateTime || ''}</td>
        </tr>
      ));
    } else {
      return userList.map(cognitoUser => {
        const user = {
          enabled: cognitoUser.Enabled,
          createdDateTime: cognitoUser.UserCreateDate,
          updatedDateTime: cognitoUser.UserLastModifiedDate,
          status: cognitoUser.UserStatus,
          id: cognitoUser.Username,
          email: this.arrayGet(cognitoUser.UserAttributes, 'email'),
          name: this.arrayGet(cognitoUser.UserAttributes, 'custom:Name'),
          emailNotification: this.arrayGet(cognitoUser.UserAttributes, 'custom:emailNotification'),
          prefectures: this.arrayGet(cognitoUser.UserAttributes, 'custom:prefectures'),
          branch: this.arrayGet(cognitoUser.UserAttributes, 'custom:branch'),
          administrator: this.arrayGet(cognitoUser.UserAttributes, 'custom:administrator'),
          isMember: this.arrayGet(cognitoUser.UserAttributes, 'custom:isMember'),
          approvalFlg: this.arrayGet(cognitoUser.UserAttributes, 'custom:approvalFlg'),
          companyUserCount: cognitoUser.companyUserCount,
          parentID: this.arrayGet(cognitoUser.UserAttributes, 'custom:ParentID'),
          maxActionDateTime: this.formatDateTime(cognitoUser.maxActionDateTime),
        };
        return user;
      })
      .filter(user => user.id)
      .map(user => (
        <tr key={user.id} onClick={(e) => this.selected(user, e)}>
          <td>{user.name}</td>
          <td>{(user.approvalFlg === 'false' && user.isMember === 'false') ? '未承認' : ((user.isMember === 'true' || user.isMember === 'True') ? '会員': '会員外')}</td>
          <td>{user.prefectures}</td>
          <td>{user.branch}</td>
          <td>{user.administrator}</td>
          <td>{user.email}</td>
          <td>{user.companyUserCount > 0 ? '有': '無'}</td>
          <td>{this.utc2jst(user.createdDateTime)}</td>
          <td>{user.maxActionDateTime || ''}</td>
        </tr>
      ));
    }
  }

  renderUserList(userList) {
    if (!userList || userList.length === 0) {
      return (
        <tr><td colSpan='8' style={{ textAlign: 'center' }}>現時点で登録されているデータはございません。</td></tr>
      );
    }
    return userList.map(cognitoUser => {
      const user = {
        enabled: cognitoUser.Enabled,
        createdDateTime: cognitoUser.UserCreateDate,
        updatedDateTime: cognitoUser.UserLastModifiedDate,
        status: cognitoUser.UserStatus,
        id: cognitoUser.Username, // user.id になるフィールド
        email: this.arrayGet(cognitoUser.UserAttributes, 'email'),
        name: this.arrayGet(cognitoUser.UserAttributes, 'custom:Name'),
        emailNotification: this.arrayGet(cognitoUser.UserAttributes, 'custom:emailNotification'),
        prefectures: this.arrayGet(cognitoUser.UserAttributes, 'custom:prefectures'),
        branch: this.arrayGet(cognitoUser.UserAttributes, 'custom:branch'),
        administrator: this.arrayGet(cognitoUser.UserAttributes, 'custom:administrator'),
        isMember: this.arrayGet(cognitoUser.UserAttributes, 'custom:isMember'),
        parentID: this.arrayGet(cognitoUser.UserAttributes, 'custom:ParentID'),
        maxActionDateTime: this.formatDateTime(cognitoUser.maxActionDateTime),
      };
      return user;
    })
    .filter(user => user.id)
    .map(user => (
      <tr key={user.id} onClick={(e) => this.selected(user, e)}>
        <td>{user.name}</td>
        <td>{user.enabled ? '有効' : '無効'}</td>
        <td>{user.email}</td>
        <td>{this.utc2jst(user.createdDateTime)}</td>
        <td>{this.utc2jst(user.updatedDateTime)}</td>
        <td>{user.maxActionDateTime || ''}</td>
      </tr>
    ));
  }

  renderPagination() {
    const totalPages = Math.ceil(this.state.userCount / this.state.itemsPerPage);
    const currentPage = this.state.currentPage;
    const maxPagesToShow = 10; // 前後に表示するページ数
    let startPage, endPage;

    if (totalPages <= maxPagesToShow) {
      // ページ数が表示するページ数より少ない場合
      startPage = 1;
      endPage = totalPages;
    } else {
      // 表示するページ数の範囲を設定
      const halfMaxPagesToShow = Math.floor(maxPagesToShow / 2);
      if (currentPage <= halfMaxPagesToShow) {
        startPage = 1;
        endPage = maxPagesToShow;
      } else if (currentPage + halfMaxPagesToShow >= totalPages) {
        startPage = totalPages - maxPagesToShow + 1;
        endPage = totalPages;
      } else {
        startPage = currentPage - halfMaxPagesToShow;
        endPage = currentPage + halfMaxPagesToShow;
      }
    }

    const pages = [];
    for (let i = startPage; i <= endPage; i++) {
      pages.push(
        <li key={i} className={currentPage === i ? 'active' : ''}>
          <a href="#" data-page={i} onClick={this.handlePageChange}>
            {i}
          </a>
        </li>
      );
    }

    return (
      <ul className="pagination">
        <li className={currentPage === 1 ? 'disabled' : ''}>
          <a href="#" data-page={1} onClick={this.handlePageChange}>
            &laquo;&laquo; 最初
          </a>
        </li>
        <li className={currentPage === 1 ? 'disabled' : ''}>
          <a href="#" data-page={currentPage - 1} onClick={this.handlePageChange}>
            &laquo; 前へ
          </a>
        </li>
        {pages}
        <li className={currentPage === totalPages || totalPages == 0 ? 'disabled' : ''}>
          <a href="#" data-page={currentPage + 1} onClick={this.handlePageChange}>
            次へ &raquo;
          </a>
        </li>
        <li className={currentPage === totalPages || totalPages == 0 ? 'disabled' : ''}>
          <a href="#" data-page={totalPages} onClick={this.handlePageChange}>
            最後 &raquo;&raquo;
          </a>
        </li>
      </ul>
    );
  }

  render() {
    if (!this.state.isLoaded) {
      return <Loading />;
    }
    let userList = this.renderCompanyList(this.state.userList);

    const { searchName, searchBranch, searchPrefectures, searchMember, searchNonMember, searchUnapproved, searchDateStart, searchDateEnd } = this.state;
    const targetBranchList = Config.branch.nameOptions;
    const targetPrefecturesList = Config.prefectures.nameOptions;
    if(this.userRoleUrl == 'admin_user') {
      return (
        <div>
          <section className='nav-page'>
            <div className='container'>
              <div className='row'>
                <div className='span8'>
                  <header className='page-header'>
                    <h3>{this.userRoleName}情報管理<br /><small>こちらから{this.userRoleName}情報を管理できます。</small></h3>
                  </header>
                </div>
                <div className='span8'>
                  <ul className='nav nav-pills'>
                    <li className='kw-btn-area'>
                      <a rel='tooltip' data-placement='left' title='新規のお知らせを登録' className='text-center kw-btn-primary' onClick={(e) => this.onPageMenuClicked('add')}>
                        <i className='icon-plus icon-large' /><br /><span>新規</span>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </section>
          <section className='page container'>
            <div className='box'>
              <div className='box-header'>
                <i className='icon-info-sign icon-large' />
                <h5>{this.userRoleName}情報</h5>
              </div>
              <div className='box-content box-table'>
                <table className='table table-hover tablesorter'>
                  <thead>
                    <tr>
                      <th>{this.userRoleName}名</th>
                      <th>アカウント有効/無効</th>
                      <th>メールアドレス</th>
                      <th className='kw-list-date'>作成日時</th>
                      <th className='kw-list-date'>最終更新日時</th>
                      <th className='kw-list-date'>最終ログイン日時</th>
                    </tr>
                  </thead>
                  <tbody>
                    {userList}
                  </tbody>
                </table>
              </div>
            </div>
          </section>
        </div>
      );
    } else {
      if (this.state.isSearched === false) {
        userList = (
          <tr key="zero">
            <td colSpan="9" className="text-center">
              データ取得中...
            </td>
          </tr>
        );
      }

      if (userList.length === 0) {
        userList = (
          <tr key="zero">
            <td colSpan="9" className="text-center">
              現在登録されている見積書はありません
            </td>
          </tr>
        );
      }

      return (
        <div>
          <section className='nav-page'>
            <div className='container'>
              <div className='row'>
                <div className='span8'>
                  <header className='page-header'>
                    <h3>{this.userRoleName}情報管理<br /><small>こちらから{this.userRoleName}情報を管理できます。</small></h3>
                  </header>
                </div>
                <div className='span8'>
                  <ul className='nav nav-pills'>
                    <li className='kw-btn-area'>
                      <a rel='tooltip' data-placement='left' title='新規の企業情報を登録' className='text-center kw-btn-primary' onClick={(e) => this.onPageMenuClicked('add')}>
                        <i className='icon-plus icon-large' /><br /><span>新規</span>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </section>
          <section className='page container'>
            <div className='box'>
              <div className='box-header'>
                <i className='icon-info-sign icon-large' />
                <h5>{this.userRoleName}情報</h5>
                <div className="btn-group-box form-search">
                  <input
                    className="search-companyname form-area"
                    type="text"
                    name="searchName"
                    value={searchName}
                    placeholder="企業名で検索"
                    onChange={this.handleSearchChange}
                  />
                  <select
                    className="search-branch form-area"
                    name="searchBranch"
                    value={searchBranch || ""}
                    onChange={this.handleSearchChange}
                  >
                    <option key="branch" value="">支部名を選択</option>
                    {targetBranchList.map((branch) => (
                      <option key={branch.name} value={branch.name}>
                        {branch.name}
                      </option>
                    ))}
                  </select>
                  <select
                    className="search-branch form-area"
                    name="searchPrefectures"
                    value={searchPrefectures || ""}
                    onChange={this.handleSearchChange}
                  >
                    <option key="prefectures" value="">都道府県を選択</option>
                    {targetPrefecturesList.map((prefectures) => (
                      <option key={prefectures.name} value={prefectures.name}>
                        {prefectures.name}
                      </option>
                    ))}
                  </select>
                  <label htmlFor='isMember' style={{cursor: 'pointer'}}>
                  <input type='checkbox' id='searchMember' name='searchMember' checked={searchMember} onChange={this.handleSearchCheck} />会員
                  </label>
                  <label htmlFor='isNonMember' style={{cursor: 'pointer'}}>
                  <input type='checkbox' id='searchNonMember' name='searchNonMember' checked={searchNonMember} onChange={this.handleSearchCheck} />会員外
                  </label>
                  <label htmlFor='isApproved' style={{cursor: 'pointer'}}>
                  <input type='checkbox' id='searchUnapproved' name='searchUnapproved' checked={searchUnapproved} onChange={this.handleSearchCheck} />未承認
                  </label>
                  <label>作成日時</label>
                  <input
                    className="search-createdate"
                    type="date"
                    name="searchDateStart"
                    value={searchDateStart}
                    placeholder="YYYY/MM/DD"
                    onChange={this.handleSearchChange}
                  />～
                  <input
                    className="search-createdate form-area"
                    type="date"
                    name="searchDateEnd"
                    value={searchDateEnd}
                    placeholder="YYYY/MM/DD"
                    onChange={this.handleSearchChange}
                  />
                  <button type="button" className="form-area text-center search-companybutton kw-btn-primary" onClick={this.handleSearch}>
                    <i className='icon-search icon-large' /><span> 検索 </span>
                  </button>
                  <button type="button" className="form-area text-center search-companybutton kw-btn-primary" onClick={this.handleReset}>
                    <i className='icon-arrow-left icon-large' /><span> リセット</span>
                  </button>
                </div>
              </div>
              <div className="box-footer">{this.renderPagination()}</div>
              <div className='box-content box-table'>
                <table className='table table-hover tablesorter'>
                  <thead>
                    <tr>
                      <th width="17%">{this.userRoleName}名</th>
                      <th width="5%">会員/会員外</th>
                      <th width="7%">都道府県名</th>
                      <th width="7%">支部名</th>
                      <th width="13%">企業管理者名</th>
                      <th width="20%">企業管理者メールアドレス</th>
                      <th width="5%">ユーザー登録有無</th>
                      <th width="13%" className='company-list-date'>作成日時</th>
                      <th width="13%" className='company-list-date'>最終ログイン日時</th>
                    </tr>
                  </thead>
                  <tbody>
                    {userList}
                  </tbody>
                </table>
              </div>
              <div className="box-footer">{this.renderPagination()}</div>
            </div>
          </section>
        </div>
      );
    }
  }
}

export default CognitoUserListPerPage;



// WEBPACK FOOTER //
// ./src/admin/pages/secure/abstract/CognitoUserListPerPage.js